var app = angular.module("leonardo");

var ApprovalDialog = function ($scope, ngDialog, ContactTypeRestService, AccountUserService, FormErrorsService,
  AccountUserRoleService, UserService, $filter, ApprovalStepService, PermissionService) {

  $scope.template = $scope.ngDialogData.template;
  $scope.data = $scope.ngDialogData.data || {};
  $scope.propertyId = $scope.ngDialogData.propertyId || $scope.template.property;
  $scope.action = $scope.ngDialogData.action;
  $scope.isEditStepInProgress = $scope.ngDialogData.isEditStepInProgress;
  $scope.permissionService = PermissionService;
  $scope.userService = UserService;
  $scope.accountUserService = AccountUserService;
  $scope.accountUserRoleService = AccountUserRoleService;
  $scope.contactTypeRestService = ContactTypeRestService;

  $scope.user_types = [
    { id: 'user', name: $filter('translate')('By User') },
    { id: 'role', name: $filter('translate')('By Role') }
  ];

  $scope.isEmpty = isEmpty;

  $scope.indexSteps = $scope.template.approval_steps.map(step => step.index);
  if ($scope.action === 'create') {
    $scope.indexSteps.push($scope.template.approval_steps.length + 1);
  }
  else {
    $scope.user_type = null;
    if (!isEmpty($scope.data.user_approvers)) {
      $scope.user_type = 'user';
    }
    else {
      $scope.user_type = !isEmpty($scope.data.user_role_approvers) ? 'role' : null;
    }
    if (isNull($scope.user_type) && $scope.isEditStepInProgress){
      $scope.user_type = 'user';
    }
    $scope.show_out_office = !isEmpty($scope.data.secondary_user_approvers) || !isEmpty($scope.data.secondary_user_role_approvers);
    $scope.show_out_user=!isEmpty($scope.data.secondary_user_approvers);
    $scope.show_out_role=!isEmpty($scope.data.secondary_user_role_approvers);
    $scope.data.days_before_escalation = $scope.data.days_before_escalation > 0 ? $scope.data.days_before_escalation : null;
    $scope.data.days_escalation_frequency = $scope.data.days_escalation_frequency > 0 ? $scope.data.days_escalation_frequency : null;
    if($scope.show_out_office) {
      if($scope.data.notify_secondary_approver_after_days && $scope.data.notify_secondary_approver_after_days > 0) {
        $scope.send_notifications_after = true;
      }
    }
  }
  $scope.canEditSteps = function (step) {
    if ($scope.permissionService.isOwner()) return true;
    var current_user = AccountUserService.currentAccountUser.user;
    let approversIds = [];
    let current_step = step || $scope.data;
    var approver = false;
    if (current_step && angular.isArray(current_step.user_approvers)) {
      current_step.user_approvers.map(user => {
        if (!approversIds.includes(user.id)) {
          approversIds.push(user.id);
        }
      });
    }
    if (approversIds.length > 0) {
      angular.forEach(approversIds, function (step_approver) {
        if (current_user.id === step_approver) {
          approver = true;
        }
      })
    }
    return approver;
  }

  $scope.isAbleToEditMainApprovers = function (data) {
    if ($scope.isEditStepInProgress) {
      if (!isEmpty(data)) {
        return (([ApprovalStepService.STATUS_IN_PROGRESS].includes(data.status ? data.status.toString() : '')) && $scope.canEditSteps(data));
      }
      return false;
    }
    else {
      return true;
    }
  };

  $scope.resetApprovers = function () {
    switch ($scope.user_type) {
      case 'user':
        $scope.data.user_role_approvers = [];
        break;
      case 'role':
        $scope.data.user_approvers = [];
        break;
    }
  }

  $scope.resetOutOffice = function () {
    $scope.data.secondary_user_approvers = [];
    $scope.send_notifications_after = false;
    $scope.data.notify_secondary_approver = false;
    $scope.data.notify_secondary_approver_after_days = '';
    $scope.data.secondary_user_role_approvers=[];
    if($scope.show_out_office){
      $scope.show_out_user=true;
    }
    else{
      $scope.show_out_user=false;
      $scope.show_out_role=false;
    }
  }

  $scope.NotifySecondaryApprover = function(isAlways) {
    if(isAlways) {
      $scope.send_notifications_after = false;
      $scope.data.notify_secondary_approver_after_days = '';
    }
    else {
      if($scope.send_notifications_after) {
        $scope.data.notify_secondary_approver = false;
      }
      else {
        $scope.data.notify_secondary_approver_after_days = '';
      }
    }
  }

  $scope.submit = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    if ($scope.isEditStepInProgress) {
      const data = {
        time_sensitive: $scope.data.time_sensitive,
        secondary_user_approvers: !isEmpty($scope.data.secondary_user_approvers) ? $scope.data.secondary_user_approvers.map(item => item.id || item) : [],
        user_approvers: !isEmpty($scope.data.user_approvers) ? $scope.data.user_approvers.map(item => item.id || item) : [],
        notify_secondary_approver: !isEmpty($scope.data.secondary_user_approvers) || !isEmpty($scope.data.secondary_user_role_approvers) ? $scope.data.notify_secondary_approver: false,
        notify_secondary_approver_after_days: ($scope.send_notifications_after && (!isEmpty($scope.data.secondary_user_approvers) || !isEmpty($scope.data.secondary_user_role_approvers))) ? $scope.data.notify_secondary_approver_after_days : 0,
        secondary_user_role_approvers: !isEmpty($scope.data.secondary_user_role_approvers) ? $scope.data.secondary_user_role_approvers.map(item => item.id || item) : []
      }
      ApprovalStepService.one($scope.data.id).patch(data).then(function (result) {
        $scope.confirm(result);
      });
    } else {
      $scope.data["has_escalation_configuration"] = ($scope.data.days_before_escalation > 0 || $scope.data.days_escalation_frequency > 0);
      $scope.data["days_before_escalation"] = $scope.data.days_before_escalation > 0 ? $scope.data.days_before_escalation : 0;
      $scope.data["days_escalation_frequency"] = $scope.data.days_escalation_frequency > 0 ? $scope.data.days_escalation_frequency : 0;
      $scope.data["notify_secondary_approver"] = !isEmpty($scope.data.secondary_user_approvers) || !isEmpty($scope.data.secondary_user_role_approvers) ? $scope.data.notify_secondary_approver: false;
      $scope.data["notify_secondary_approver_after_days"] = ($scope.send_notifications_after && (!isEmpty($scope.data.secondary_user_approvers) || !isEmpty($scope.data.secondary_user_role_approvers))) ? $scope.data.notify_secondary_approver_after_days : 0;
      $scope.confirm($scope.data);
    }
  }
  $scope.resetOutOfficeType = function (){
  if(!$scope.show_out_user && !$scope.show_out_role){
    $scope.show_out_office=false;
  }
  if(!$scope.show_out_user){
    $scope.data.secondary_user_approvers=[];
  }
  if(!$scope.show_out_role){
    $scope.data.secondary_user_role_approvers=[];
  }
}
};


app.controller('ApprovalDialog', ['$scope', 'ngDialog', 'ContactTypeRestService', 'AccountUserService',
  'FormErrorsService', 'AccountUserRoleService', 'UserService', '$filter', 'ApprovalStepService', 'PermissionService', ApprovalDialog]);
